import React from "react";
import TextInput from "../common/inputs/textInput";
// import NotificationManager from './common/notifications/NotificationManager';
import Loading from "../common/loading";
import Logo from "../../synaccess_white.svg";
import { Link } from "react-router-dom";

export default class SamlLogin extends React.Component {
  state = {
    username: "",
    usernameError: "",
    loading: false,
    logo: Logo,
    logoWidth: "170px",
  };
  submit() {
    this.setState({
      usernameError: "",
      loading: true,
    });
    if (!this.state.username) {
      this.setState({
        usernameError: "Missing Username",
        loading: false,
      });
    } else {
      this.props.fetchSamlLogin(
        this.state.username,
        (err, ssoLoginUrlObj) => {
          if (err) {
            this.setState({
              loading: false,
            });
          } else {
            const ssoLoginUrl =
              ssoLoginUrlObj?.data?.SSO_LOGIN_URL || ssoLoginUrlObj?.data?.SAML_LOGIN_URL;
            if (!ssoLoginUrl) {
              this.setState({
                usernameError: "Unable to start SSO",
                loading: false,
              });
              return;
            }

            window.location.href = ssoLoginUrl;
            this.setState({
              loading: false,
            });
          }
        },
      );
    }
  }
  render() {
    const {
      username,
      usernameError,
      loading,
    } = this.state;

    return (
      <div
        style={{
          height: "117.7vh",
          overflow: "auto",
        }}
        className="background-gradient"
      >
        <div className="grid-container">
          <div className="grid-x grid-padding-x grid-padding-y align-center">
            <div
              className="cell large-6 medium-8 small-10"
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div
                // className="app-item"
                style={{
                  padding: "0px",
                  marginTop: "10vh",
                  borderRadius: "2px",
                  // boxShadow: '2px 3px 3px rgba(0,0,0,0.1)',
                  maxWidth: "520px",
                  minWidth: "350px",
                  // border: "solid red 1px"
                }}
              >
                <div
                  style={{
                    // maxHeight: "60px",
                    // border: "solid red 1px"
                    paddingBottom: "20px",
                  }}
                >
                  <img alt="logo" src={this.state.logo} width={this.state.logoWidth} />
                </div>
                <div
                  style={{
                    // boxShadow: "2px 3px 3px rgba(0,0,0,0.15)",

                    boxShadow: "3px 3px 20px rgba(0,0,0,0.05)",
                  }}
                >
                  <div
                    style={{
                      // backgroundColor: "#1d262f",
                      padding: "30px 0px 0px 50px",
                      // color: "white",
                      borderRadius: "2px",
                      // display: 'flex',
                      // justifyContent: 'center',
                      fontSize: "125%",
                      fontWeight: "600",
                      backgroundColor: "white",
                    }}
                  >
                    Sign in with SSO
                  </div>
                  <div
                    style={{
                      backgroundColor: "white",
                      padding: "20px 50px 30px 50px",
                      borderRadius: "3px",
                    }}
                  >
                  <p>
                    Enter your corporate email to continue to your organization’s Single Sign-On
                  </p>
                    <form
                      onSubmit={(e) => {
                        e.preventDefault();
                        this.submit();
                      }}
                    >
                      <TextInput
                        label="Work Email"
                        placeholder="Email"
                        value={username}
                        error={usernameError}
                        callback={(data) => this.setState({ username: data })}
                        tabIndex="1"
                      />
                      {this.props.errMessage && (
                        <div
                          style={{
                            padding: "10px 0px 20px 0px",
                            color: "maroon",
                          }}
                        >
                          {this.props.errMessage}
                        </div>
                      )}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          paddingBottom: "20px",
                        }}
                      >
                        <button
                          className="button"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            fontWeight: "600",
                            width: "100%",
                            boxShadow: "3px 3px 3px rgba(0,0,0,0.1)",
                            color: "white",
                          }}
                          // onClick={() => this.submit()}
                          type="submit"
                        >
                          {loading ? <Loading /> : "Continue"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
                <div
                  style={{
                    padding: "20px 10px 10px 10px",
                    color: "white",
                  }}
                >
                  <Link to="/login">
                    <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-start",
                          cursor: "pointer",
                          color: "white"
                        }}
                    >
                        <i className="material-icons">arrow_back</i>
                        <b style={{ color: "white" }}>Go back</b>
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
